const translations = {
    cz: {
        hledat: 'Vyhledat',
        doKosiku: 'Koupit',
        zobrazitVsechnyProdukty: 'Zobrazit všechny produkty',
        zakaznickyUcet: 'Máte u nás účet?',
        prihlasteSe: 'Přihlaste se a doručovací údaje se vyplní automaticky.',
        prihlasitSe: 'Přihlásit se',
        emailLogin: 'E-mail',
        hesloLogin: 'Heslo',
        continueInOrder: 'Pokračovat v objednávce',
        cartProdukt: 'Produkt',
        cartDostupnost: 'Dostupnost',
        cartPocet: 'Počet',
        cartCenaZaKus: 'Cena za kus',
        cartCelkem: 'Celkem',
        cartsleva: 'Sleva',
        zpetdoobchodu: 'Zpět do obchodu',
        seraditDle: 'Seřadit dle',
        filtrovani: 'Filtrování',
        polozekCelkem: 'produktů',
        detailniPopisProduktu: 'Detailní popis produktu',
        produktJe: 'Produkt je',
        pridatDoKosiku: 'Vložit do košíku',
        vcetneDph: 'cena včetně DPH',
        nezarazeneParam: 'Nezařazené parametry',
        souvisejiciProdukty: 'Související produkty',
        cartPcartCenaZaKusrodukt: 'Cena za kus',
    }
};

function translation(key) {
    const lang = $('html').attr('lang') || 'cz';
    const parts = key.split('.');
    const requestedLang = parts.length > 1 ? parts[0] : lang;
    const realKey = parts.length > 1 ? parts[1] : parts[0];
    return translations[requestedLang] && translations[requestedLang][realKey]
        ? translations[requestedLang][realKey]
        : translations['cz'][realKey] || key;
}